import { render, staticRenderFns } from "./FilterCheckbox.vue?vue&type=template&id=864dc772&scoped=true&"
import script from "./FilterCheckbox.vue?vue&type=script&lang=js&"
export * from "./FilterCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./FilterCheckbox.vue?vue&type=style&index=0&id=864dc772&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "864dc772",
  null
  
)

export default component.exports